import {
  BILLCOM_PO_RECONCILIATION_REPORT_TYPE,
  BILLCOM_AP_WRITEBACK_STATUS_REPORT_TYPE,
  BILLCOM_BANK_CASH_RECON_REPORT_TYPE,
  EADIN_CATALOG_REPORT_TYPE,
  EADIN_INVENTORY_REPORT_TYPE,
} from './cronTypes';

// Add a report ID here to give that report the shared scheduling gear.
export const SCHEDULABLE_REPORTS = {
  'billcom-po-reconciliation': {
    cronType: BILLCOM_PO_RECONCILIATION_REPORT_TYPE,
    filenamePrefix: 'billcom_po_reconciliation',
  },
  'billcom-ap-writeback-status': {
    cronType: BILLCOM_AP_WRITEBACK_STATUS_REPORT_TYPE,
    filenamePrefix: 'billcom_ap_writeback_status',
  },
  'billcom-bank-cash-recon': {
    cronType: BILLCOM_BANK_CASH_RECON_REPORT_TYPE,
    filenamePrefix: 'billcom_bank_cash_recon',
  },
  'eadin-catalog': {
    cronType: EADIN_CATALOG_REPORT_TYPE,
    filenamePrefix: 'eadin_catalog',
  },
  'eadin-inventory': {
    cronType: EADIN_INVENTORY_REPORT_TYPE,
    filenamePrefix: 'eadin_inventory',
  },
};
